import { BaseEntity } from '@/types';

export type FormFieldGroup = {
  name: string;
  key: 'owner' | 'pet';
  formFields: FormField[];
} & BaseEntity;

export type FormField = {
  businessId?: string;
  businessLocationId?: string;
  fieldLabel: string;
  fieldDescription: string;
  fieldType: string;
  fieldValue: any;
  isValid?: boolean;
  defaultValue?: string;
  placeholder?: string;
  fieldName: string;
  disabled: boolean;
  isRequired?: boolean;
  options?: FieldOptions[];
  orderIndex: number;
  category: 'pet' | 'owner';
} & BaseEntity;

export type SaveFormField = {
  orderIndex: number;
  id: string;
};

export type FieldOptions = {
  label: string;
  value: string;
};

export type VaccineFormData = {
  vaccineList: Vaccine[];
  vaccine?: Vaccine;
};

export type Vaccine = {
  documentLink?: string;
  takenDate?: string;
  expiryDate?: string;
  type?: string;
  fileName?: string;
  fileSize?: string;
};

export type Address = {
  address: string;
  country: string;
  zipCode: string;
} & BaseEntity;

export const ItemTypes = {
  CARD: 'card',
};
